import { request } from './request';

const enc = encodeURIComponent;

/**
 * The public read behind a share token. Unauthenticated: the token is the
 * credential, and it stays on this page — it is never put in the frame's URL,
 * where the dashboard's own script could read it out of location.search.
 *
 * @param {string} token
 * @returns {Promise<{slug:string, title:string, version:number, sdkVersion:string, queries:string[]}>}
 */
export const getShared = (token) => request(`/api/shares/${enc(token)}`);

/**
 * Run one query the shared dashboard's pinned manifest declares. The name is
 * the only input; the server reads the device, channel, op and window from the
 * stored manifest, so this cannot reach anything the link was not minted for.
 *
 * @param {string} token
 * @param {string} name  a key from the share record's `queries`
 * @param {AbortSignal} signal
 * @returns {Promise<any>}
 */
export const runSharedQuery = (token, name, signal) =>
  request(`/api/shares/${enc(token)}/q/${enc(name)}`, { signal });

/**
 * @param {string} slug
 * @returns {Promise<{id:string, token:string, url:string, createdAt:string}>}
 *   `token` is returned by the API exactly once and is not recoverable later.
 */
export const mintShare = (slug) =>
  request(`/api/dashboards/${enc(slug)}/shares`, { method: 'POST', json: {} });

/** @returns {Promise<Array<{id:string, createdAt:string, revokedAt:string|null, revokedReason:string|null}>>} */
export const listShares = (slug) => request(`/api/dashboards/${enc(slug)}/shares`);

/** @returns {Promise<void>} */
export const revokeShare = (slug, id) =>
  request(`/api/dashboards/${enc(slug)}/shares/${enc(id)}`, { method: 'DELETE' });
